module.exports = __webpack_public_path__ + "img/Willem-full.b4eb8961.png";